import { convertFromCentsToDollars } from "utils/calculateCurrency/calculateTotalCurrency";

export const buildTableDesktopThs = (plans = []) => [
  {
    id: "firstTh",
    header: "Options and benefits"
  },
  ...plans.map(plan => ({
    ...plan,
    planName: plan.name,
    price: convertFromCentsToDollars(plan.price)
  }))
];
